module.exports = __webpack_public_path__ + "media/images/gobble_july4th/bg-xs-a5a95c74310acb22d72771f49a35d555.jpg";